import { useDispatch } from 'react-redux'
import ExportButton from '../../common/ExportButton'
import { boliBookingExportColumns } from '../../config/exportColumns/boliBookingExportColumns'
import { appAllGetBoliBooking } from '../../store/boliBooking'
import TableFilter from './tableFilter'

function BoliBooking() {
	const dispatch = useDispatch()
	return (
		<>
			<div className="content-wrapper">
				<div
					className="content-heading d-flex
                          justify-content-between"
				>
					<div>Boli Booking</div>
					<div>
						<ExportButton
							fetchAction={params => dispatch(appAllGetBoliBooking({ ...params, loading: false }))}
							filters={{}}
							columns={boliBookingExportColumns}
							fileName="Boli Bookings"
							sheetName="Boli Booking List"
							buttonText="Export Boli Bookings"
						/>
					</div>
				</div>
				<TableFilter />
			</div>
		</>
	)
}

export default BoliBooking
